'use strict'

function buildAddress (address) {
  let compiledAddress = []

  if (address.address1) { compiledAddress.push(address.address1) }

  if (address.address2) {
    if (compiledAddress.length > 0) {
      compiledAddress.push('<br>')
    }

    compiledAddress.push(address.address2)
  }

  compiledAddress.push('<br>')
  compiledAddress.push(`${address.city}, `)
  compiledAddress.push(`${address.state} `)
  compiledAddress.push(address.postalCode)
  return compiledAddress.join('')
}

function buildAddressOneLine (address) {
  return buildAddress(address).replaceAll('<br>', ', ')
}

function buildAddressLink (address) {
  return `https://www.bing.com/maps?where1=${encodeURIComponent(buildAddressOneLine(address))}&sty=r&lvl=11&FORM=MBEDLD`
}

export default {
  buildAddress: buildAddress,
  buildAddressOneLine: buildAddressOneLine,
  buildAddressLink: buildAddressLink
}



// WEBPACK FOOTER //
// ./src/js/common/AddressHelper.js